var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegamarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.748 26.206h-2.11v-8.921h-.122l-3.507 8.428H9.392l-3.507-8.428h-.123v8.92h-2.11V13.524h2.655l3.814 9.237h.158l3.815-9.237h2.654v12.683zm3.174.184c-.41 0-.747-.132-1.01-.395a1.347 1.347 0 0 1-.396-.994c0-.404.132-.735.396-.993.263-.263.6-.395 1.01-.395.416 0 .753.132 1.011.395.264.258.396.59.396.994 0 .398-.132.729-.396.993-.258.263-.595.395-1.01.395zm16.27-.184h-2.11v-8.921h-.122l-3.507 8.428h-1.617l-3.507-8.428h-.123v8.92h-2.11V13.524h2.655l3.814 9.237h.159l3.814-9.237h2.654v12.683z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A673EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E4CC4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegamarket);
export default __webpack_public_path__ + "static/media/megamarket.e0fd8117c20109335bafd733e5f9f118.svg";
export { ForwardRef as ReactComponent };